/**
 * form公共组件:可以用作搜索栏+ modal栏
 */
<template>
  <div class="search-form-box">
    <el-form
      :model="formData"
      ref="formRef"
      :inline="inline"
      :label-width="labelWidth"
    >
      <el-form-item
        v-for="(item, index) in formOptions"
        :key="newKeys[index]"
        :prop="item.prop"
        :label="item.label ? (item.label + '：') : ''"
        :rules="item.rules"
      >
          <formItem
          v-model="formData[item.prop]"
          :itemOptions="item"
          :size="size"
        />
      </el-form-item>
      <!-- 提交按钮 -->
      <el-form-item>
    <!-- <div class="btn-box"> -->
      <el-button
        v-if="btnItems.includes('search')"
        :size="size"
        type="primary"
        class="btn-search"
        @click="onSearch"
      >搜索</el-button>

      <el-button
        v-if="btnItems.includes('export')"
        :size="size"
        type="primary"
        class="btn-export"
        @click="onExport"
      >导出</el-button>

      <el-button
        v-if="btnItems.includes('reset')"
        :size="size"
        type="default"
        class="btn-reset"
        @click="onReset"
      >重置</el-button>
    <!-- </div> -->
      </el-form-item>
    </el-form>


  </div>
</template>

<script>
import formItem from './formItem'
import tools from './tools'

export default {
  props: {
    /**
     * 表单配置
     * 示例：
     * [{
     *   label: '用户名', // label文字
     *   prop: 'username', // 字段名
     *   type: 'input', // 指定组件  例如 el-input
     *   initValue: '阿黄', // 字段初始值
     *   placeholder: '请输入用户名', // elementui组件属性
     *   rules: [{ required: true, message: '必填项', trigger: 'blur' }], // elementui组件属性
     *   events: { // elementui组件方法
     *     input (val) {
     *       console.log(val)
     *     },
     *     ...... // 可添加任意elementui组件支持的方法
     *   }
     *   ...... // 可添加任意elementui组件支持的属性
     * }]
     */
    labelWidth:{
      type:String,
      required:false,
      default:'100px'
    },
    size:'default',
    formOptions: {
      type: Array,
      required: true,
      default () {
        return []
      }
    },
    // 提交按钮项，多个用逗号分隔（search, export, reset）
    btnItems: {
      type: String,
      default () {
        return 'search'
      }
    },
    inline:{
      type: Boolean,
      default:true
    },
    value:{
      type:Object,
      required: false,
      default(){
        return {}
      }
    }
  },

  data () {
    return {
      formData: this.value || {}
    }
  },

  computed: {
    newKeys () {
      return this.formOptions.map(v => {
        return tools.createUniqueString()
      })
    }
  },

  // created () {
  //   this.addInitValue()
  // },
  watch: {
    formData: {
      handler(newVal, oldVal) {
        console.log('newVal, oldVal: ', newVal, oldVal);

        this.$emit('input',newVal)
      // ...
    },
    deep: true,
    immediate: true
    },
    value:{
      handler(newVal, oldVal){
        if(JSON.stringify(newVal) !== JSON.stringify(this.formData)){
          this.addInitValue()
        }
      },
      deep: true
    }
  },

  methods: {
    // 校验
    onValidate (callback) {
      this.$refs.formRef.validate(valid => {
        if (valid) {
          console.log('提交成功')
          console.log(this.formData)
          callback()
        }
      })
    },
    // 搜索
    onSearch () {
      this.onValidate(() => {
        this.$emit('onSearch', this.formData)
      })
    },
    // 导出
    onExport () {
      this.onValidate(() => {
        this.$emit('onExport', this.formData)
      })
    },
    onReset () {
      console.log("onReset")
      this.$refs.formRef.resetFields()
      this.formData ={}
    },
    // 添加初始值,使用val赋值初始值
    addInitValue () {
      // const obj = {}
      // this.formOptions.forEach(v => {
      //   if (v.initValue !== undefined) {
      //     debugger
      //     obj[v.prop] = v.initValue
      //   }
      // })
      this.formData = this.value || {}
      console.log('this.val: ', this.val);
    }
  },

  components: { formItem }
}
</script>

<style lang='scss' scoped>
.search-form-box {
  // display: flex;
  margin-bottom: 15px;

  .btn-box {
    padding-top: 10px;
    display: flex;

    // button {
    //   height: 28px;
    // }
  }
  .el-form {
    /deep/ .el-form-item__label {
      padding-right: 0;

    }
    .el-form-item {
      margin-top: 10px;
      margin-bottom: 0;

      &.is-error {
        margin-bottom: 22px;
      }
    }
   /deep/ .el-date-editor {
     .el-range-separator{
       width:8%;
     }

}
    // el-input宽度
    // /deep/ .form-item {
    //   > .el-input:not(.el-date-editor) {
    //     width: 200px;
    //   }
    // }
    // /deep/ .el-select {
    //   width: 200px;
    // }
    // /deep/ .el-cascader {
    //   width: 240px;
    // }
    // /deep/ .el-form-item__content{
    //   float:left;
    // }
  }
}

</style>



// WEBPACK FOOTER //
// src/lib/form.vue